import {
  meterPercent,
  type MeteredLimit,
  type OrgUsage,
} from "@/lib/api/organizations";
import { formatBytes } from "@/lib/format";
import type { RailMeter } from "./StorageIndicator";

/// How each allowance is named and counted in the rail. Bytes and counts read
/// differently, so the formatter travels with the label.
const RAIL_LIMITS: {
  key: MeteredLimit;
  label: string;
  format: (n: number) => string;
  low: string;
  nearlyGone: string;
}[] = [
  {
    key: "storage",
    label: "Storage",
    format: formatBytes,
    low: "Storage running low",
    nearlyGone: "Storage almost full",
  },
  {
    key: "egress",
    label: "Egress",
    format: formatBytes,
    low: "Egress running low",
    nearlyGone: "Egress almost spent",
  },
  {
    key: "mcp_calls",
    label: "MCP tool calls",
    format: (n) => n.toLocaleString(),
    low: "MCP tool calls running low",
    nearlyGone: "MCP tool calls almost used up",
  },
];

/// The fullest allowance, if any has reached `threshold`; `null` keeps the
/// widget off the rail.
export function nearestLimit(
  usage: OrgUsage | null,
  threshold: number,
): RailMeter | null {
  if (!usage) return null;
  let worst: RailMeter | null = null;
  for (const row of RAIL_LIMITS) {
    const meter = usage[row.key];
    const percentage = meterPercent(meter);
    if (percentage === null || percentage < threshold) continue;
    if (worst && worst.percentage >= percentage) continue;
    worst = {
      label: row.label,
      usedText: `${row.format(meter.used)} of ${row.format(meter.limit ?? 0)}`,
      percentage,
      statusMessage: percentage >= 90 ? row.nearlyGone : row.low,
    };
  }
  return worst;
}
